import React, { Component } from 'react';
import Http from '../../Http';
import { AuthContext } from '../../context/authContext';
import toast from 'react-hot-toast';

const PRESET_COLORS_1 = [
  { name: 'Naranja SOLEXX', hex: '#f97316' },
  { name: 'Azul Real', hex: '#2563eb' },
  { name: 'Índigo', hex: '#4f46e5' },
  { name: 'Verde Esmeralda', hex: '#059669' },
  { name: 'Rojo Carmesí', hex: '#dc2626' },
  { name: 'Grafito Oscuro', hex: '#0f172a' },
];

const PRESET_COLORS_2 = [
  { name: 'Ámbar Suave', hex: '#ffc68a' },
  { name: 'Cielo Claro', hex: '#93c5fd' },
  { name: 'Púrpura Suave', hex: '#c7d2fe' },
  { name: 'Menta', hex: '#a7f3d0' },
  { name: 'Gris Neutro', hex: '#94a3b8' },
  { name: 'Gris Pizarra', hex: '#64748b' },
];

export default class Personalizacion extends Component {
  static contextType = AuthContext;

  state = {
    loading: true,
    saving: false,
    nombre_sistema: '',
    logo_url: '',
    logo_file: null,
    logo_preview: null,
    color_1: '#f97316',
    color_2: '#94a3b8',
    isDragOver: false,
  };

  componentDidMount() {
    this.loadData();
  }

  componentWillUnmount() {
    if (this.state.logo_preview && this.state.logo_preview.startsWith('blob:')) {
      URL.revokeObjectURL(this.state.logo_preview);
    }
  }

  formatHexWithHash(c, fallback) {
    if (!c || c === 'null' || c === 'undefined') return fallback;
    const clean = c.toString().trim().replace(/^#+/, '');
    if (clean.length === 3) {
      return `#${clean.split('').map(x => x + x).join('')}`;
    }
    if (clean.length === 6 || clean.length === 8) {
      return `#${clean}`;
    }
    return fallback;
  }

  loadData = async () => {
    this.setState({ loading: true });
    try {
      const res = await Http.get('prop/user');
      if (!res.error && res.data) {
        const d = res.data;
        this.setState({
          nombre_sistema: d.nombre_sistema || '',
          logo_url: d.logo_url || '',
          color_1: this.formatHexWithHash(d.color_1, '#f97316'),
          color_2: this.formatHexWithHash(d.color_2, '#94a3b8'),
        });
      } else {
        toast.error('No se pudo cargar la configuración de personalización');
      }
    } catch (error) {
      console.error('[Personalizacion@loadData]', error);
      toast.error('Error al consultar los datos del servidor');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleTextChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleColorChange = (key, hex) => {
    let clean = hex.trim();
    if (!clean.startsWith('#')) {
      clean = `#${clean}`;
    }
    this.setState({ [key]: clean });
  };

  handleFileSelect = (file) => {
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      toast.error('Por favor selecciona un archivo de imagen válido (PNG, JPG, SVG, WEBP)');
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      toast.error('El tamaño de la imagen no debe superar los 10MB');
      return;
    }

    if (this.state.logo_preview && this.state.logo_preview.startsWith('blob:')) {
      URL.revokeObjectURL(this.state.logo_preview);
    }

    const previewUrl = URL.createObjectURL(file);
    this.setState({
      logo_file: file,
      logo_preview: previewUrl,
    });
  };

  handleFileInputChange = (e) => {
    const file = e.target.files && e.target.files[0];
    this.handleFileSelect(file);
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragOver: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragOver: false });
  };

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragOver: false });
    const file = e.dataTransfer.files && e.dataTransfer.files[0];
    this.handleFileSelect(file);
  };

  handleRemoveNewFile = () => {
    if (this.state.logo_preview && this.state.logo_preview.startsWith('blob:')) {
      URL.revokeObjectURL(this.state.logo_preview);
    }
    this.setState({
      logo_file: null,
      logo_preview: null,
    });
  };

  handleSubmit = async (e) => {
    if (e) e.preventDefault();
    const { nombre_sistema, color_1, color_2, logo_file } = this.state;

    this.setState({ saving: true });
    try {
      const postData = new FormData();
      postData.append('nombre_sistema', nombre_sistema || '');
      postData.append('color_1', color_1 ? color_1.replace('#', '') : '');
      postData.append('color_2', color_2 ? color_2.replace('#', '') : '');

      if (logo_file) {
        postData.append('logo', logo_file);
      }

      const res = await Http.post('prop/user/save', postData);
      if (!res.error && res.data) {
        toast.success('¡Personalización guardada exitosamente!');
        const updated = res.data;
        const newLogo = updated.logo_url || this.state.logo_url;

        this.setState({
          logo_url: newLogo,
          logo_file: null,
          logo_preview: null,
        });

        // Update context & document properties
        if (this.context && this.context.updateProp) {
          this.context.updateProp(updated);
        } else {
          if (updated.nombre_sistema) document.title = updated.nombre_sistema;
          if (updated.color_1) {
            localStorage.setItem('solexx-color1', updated.color_1);
            document.documentElement.style.setProperty('--accent-color', `#${updated.color_1}`);
          }
          if (updated.color_2) localStorage.setItem('solexx-color2', updated.color_2);
          if (updated.logo_url) localStorage.setItem('solexx-logo', updated.logo_url);
        }
      } else {
        toast.error(res.errMsg || 'No se pudo guardar la personalización');
      }
    } catch (error) {
      console.error('[Personalizacion@onSubmit]', error);
      toast.error('Error al conectar con el servidor para guardar');
    } finally {
      this.setState({ saving: false });
    }
  };

  render() {
    const {
      loading,
      saving,
      nombre_sistema,
      logo_url,
      logo_file,
      logo_preview,
      color_1,
      color_2,
      isDragOver,
    } = this.state;

    if (loading) {
      return (
        <div className="w-full flex flex-col items-center justify-center p-16">
          <div className="w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mb-4" />
          <p className="text-gray-500 text-sm font-medium">Cargando datos de personalización...</p>
        </div>
      );
    }

    const currentLogoDisplay = logo_preview || logo_url;

    return (
      <form onSubmit={this.handleSubmit} className="space-y-8">
        {/* Section 1: System Name */}
        <div className="border-b border-gray-100 pb-8">
          <div className="flex items-start justify-between gap-4 mb-4">
            <div>
              <h3 className="text-lg font-bold text-gray-900">Nombre de la Aplicación</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Define el nombre visible de tu empresa en el sistema, la barra lateral y los títulos de pestaña.
              </p>
            </div>
            <span className="text-xs font-semibold px-2.5 py-1 bg-gray-100 text-gray-600 rounded-md">
              General
            </span>
          </div>

          <div className="max-w-xl">
            <label htmlFor="nombre_sistema" className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
              Nombre Comercial / Razón
            </label>
            <div className="relative rounded-lg shadow-2xs">
              <input
                type="text"
                id="nombre_sistema"
                name="nombre_sistema"
                value={nombre_sistema}
                onChange={this.handleTextChange}
                placeholder="Ej. SOLEXX Logística"
                className="w-full px-4 py-2.5 bg-gray-50/50 border border-gray-200 rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:bg-white focus:outline-hidden focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all"
              />
            </div>
            <p className="text-xs text-gray-400 mt-1.5">
              Si se deja vacío, el sistema mostrará "SOLEXX" por defecto.
            </p>
          </div>
        </div>

        {/* Section 2: Logo */}
        <div className="border-b border-gray-100 pb-8">
          <div className="flex items-start justify-between gap-4 mb-4">
            <div>
              <h3 className="text-lg font-bold text-gray-900">Logotipo Institucional</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Sube el logo de tu empresa para la barra lateral de navegación y encabezados del sistema.
              </p>
            </div>
            <span className="text-xs font-semibold px-2.5 py-1 bg-orange-50 text-orange-700 border border-orange-200 rounded-md">
              PNG / SVG recomendado
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
            {/* Current / Preview Card */}
            <div className="md:col-span-4 bg-gray-50/80 rounded-xl p-4 border border-gray-200/80 flex flex-col items-center text-center">
              <span className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3">
                {logo_preview ? 'Vista Previa Seleccionada' : 'Logo Actual'}
              </span>
              <div className="w-full h-32 bg-white rounded-lg border border-gray-200 flex items-center justify-center p-3 shadow-2xs overflow-hidden relative group">
                {currentLogoDisplay ? (
                  <img
                    src={currentLogoDisplay}
                    alt="Logo del sistema"
                    className="max-h-full max-w-full object-contain"
                  />
                ) : (
                  <div className="flex flex-col items-center justify-center text-gray-400">
                    <svg className="w-10 h-10 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span className="text-xs font-medium">Sin logo asignado</span>
                  </div>
                )}
              </div>
              {logo_file && (
                <button
                  type="button"
                  onClick={this.handleRemoveNewFile}
                  className="mt-3 text-xs text-red-600 hover:text-red-700 font-semibold cursor-pointer transition-colors"
                >
                  ✕ Descartar imagen seleccionada
                </button>
              )}
            </div>

            {/* Upload Dropzone */}
            <div className="md:col-span-8">
              <div
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragLeave}
                onDrop={this.handleDrop}
                className={`relative border-2 border-dashed rounded-xl p-6 text-center transition-all ${
                  isDragOver
                    ? 'border-orange-500 bg-orange-50/50'
                    : 'border-gray-200 hover:border-gray-300 bg-white'
                }`}
              >
                <input
                  type="file"
                  id="logo-file-input"
                  accept="image/png,image/jpeg,image/svg+xml,image/webp"
                  onChange={this.handleFileInputChange}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                />
                <div className="flex flex-col items-center pointer-events-none">
                  <div className="w-12 h-12 rounded-full bg-orange-50 text-orange-600 flex items-center justify-center mb-3">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                    </svg>
                  </div>
                  <p className="text-sm font-semibold text-gray-800">
                    Arrastra tu nuevo archivo aquí, o <span className="text-orange-600 underline">haz clic para explorar</span>
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    Archivos compatibles: PNG, JPG, SVG, WEBP (Máximo 10 MB).
                  </p>
                </div>
              </div>

              {logo_file && (
                <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg flex items-center justify-between text-xs text-green-800">
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="font-medium truncate max-w-xs">{logo_file.name}</span>
                    <span className="text-green-600">({(logo_file.size / 1024).toFixed(1)} KB)</span>
                  </div>
                  <span className="font-semibold">Listo para guardar</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Section 3: Colors */}
        <div className="border-b border-gray-100 pb-8">
          <div className="flex items-start justify-between gap-4 mb-4">
            <div>
              <h3 className="text-lg font-bold text-gray-900">Paleta de Colores</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Personaliza los tonos principales de la interfaz, botones y elementos destacados.
              </p>
            </div>
            <span className="text-xs font-semibold px-2.5 py-1 bg-gray-100 text-gray-600 rounded-md">
              Tema Visual
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Color Primario */}
            <div className="bg-gray-50/50 rounded-xl p-5 border border-gray-200/80">
              <div className="flex items-center justify-between mb-3">
                <label className="text-xs font-bold text-gray-700 uppercase tracking-wider">
                  Color Primario
                </label>
                <div
                  className="w-7 h-7 rounded-lg border border-gray-300 shadow-2xs"
                  style={{ backgroundColor: color_1 }}
                />
              </div>

              <div className="flex items-center gap-3 mb-4">
                <input
                  type="color"
                  value={color_1}
                  onChange={(e) => this.handleColorChange('color_1', e.target.value)}
                  className="w-12 h-11 p-1 rounded-lg border border-gray-300 cursor-pointer bg-white"
                />
                <input
                  type="text"
                  value={color_1}
                  onChange={(e) => this.handleColorChange('color_1', e.target.value)}
                  placeholder="#f97316"
                  maxLength={7}
                  className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-sm font-mono text-gray-800 focus:outline-hidden focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500"
                />
              </div>

              <div>
                <span className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider block mb-2">
                  Paleta sugerida
                </span>
                <div className="flex flex-wrap gap-2">
                  {PRESET_COLORS_1.map((c) => (
                    <button
                      key={c.hex}
                      type="button"
                      onClick={() => this.handleColorChange('color_1', c.hex)}
                      title={c.name}
                      className={`w-7 h-7 rounded-lg border transition-transform cursor-pointer ${
                        color_1.toLowerCase() === c.hex.toLowerCase()
                          ? 'scale-110 border-gray-900 shadow-sm ring-2 ring-gray-400'
                          : 'border-white/50 hover:scale-105'
                      }`}
                      style={{ backgroundColor: c.hex }}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Color Secundario */}
            <div className="bg-gray-50/50 rounded-xl p-5 border border-gray-200/80">
              <div className="flex items-center justify-between mb-3">
                <label className="text-xs font-bold text-gray-700 uppercase tracking-wider">
                  Color Secundario
                </label>
                <div
                  className="w-7 h-7 rounded-lg border border-gray-300 shadow-2xs"
                  style={{ backgroundColor: color_2 }}
                />
              </div>

              <div className="flex items-center gap-3 mb-4">
                <input
                  type="color"
                  value={color_2}
                  onChange={(e) => this.handleColorChange('color_2', e.target.value)}
                  className="w-12 h-11 p-1 rounded-lg border border-gray-300 cursor-pointer bg-white"
                />
                <input
                  type="text"
                  value={color_2}
                  onChange={(e) => this.handleColorChange('color_2', e.target.value)}
                  placeholder="#94a3b8"
                  maxLength={7}
                  className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-sm font-mono text-gray-800 focus:outline-hidden focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500"
                />
              </div>

              <div>
                <span className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider block mb-2">
                  Paleta sugerida
                </span>
                <div className="flex flex-wrap gap-2">
                  {PRESET_COLORS_2.map((c) => (
                    <button
                      key={c.hex}
                      type="button"
                      onClick={() => this.handleColorChange('color_2', c.hex)}
                      title={c.name}
                      className={`w-7 h-7 rounded-lg border transition-transform cursor-pointer ${
                        color_2.toLowerCase() === c.hex.toLowerCase()
                          ? 'scale-110 border-gray-900 shadow-sm ring-2 ring-gray-400'
                          : 'border-white/50 hover:scale-105'
                      }`}
                      style={{ backgroundColor: c.hex }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section 4: Live Branding Preview */}
        <div className="border-b border-gray-100 pb-8">
          <div className="mb-4">
            <h3 className="text-lg font-bold text-gray-900">Vista Previa de Marca en Tiempo Real</h3>
            <p className="text-sm text-gray-500 mt-0.5">
              Así es como lucirá tu marca en el encabezado de navegación lateral y componentes principales.
            </p>
          </div>

          <div className="bg-[#0f172a] rounded-xl p-5 text-white shadow-md border border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              {currentLogoDisplay ? (
                <img
                  src={currentLogoDisplay}
                  alt="preview"
                  className="h-10 w-10 object-contain rounded-lg bg-white/10 p-1"
                />
              ) : (
                <div
                  className="h-10 w-10 rounded-lg text-white font-bold flex items-center justify-center text-sm shadow-sm"
                  style={{ backgroundColor: color_1 }}
                >
                  {(nombre_sistema || 'SX').slice(0, 2).toUpperCase()}
                </div>
              )}
              <div>
                <h4 className="font-bold text-base tracking-wide text-white">
                  {nombre_sistema || 'SOLEXX'}
                </h4>
                <p className="text-xs text-gray-400">Plataforma Logística y Operativa</p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <button
                type="button"
                className="px-4 py-2 rounded-lg text-xs font-semibold text-white shadow-xs transition-opacity"
                style={{ backgroundColor: color_1 }}
              >
                Botón Principal
              </button>
              <button
                type="button"
                className="px-4 py-2 rounded-lg text-xs font-semibold text-white shadow-xs transition-opacity"
                style={{ backgroundColor: color_2 }}
              >
                Botón Secundario
              </button>
            </div>
          </div>
        </div>

        {/* Submit Action */}
        <div className="flex items-center justify-end gap-3 pt-2">
          <button
            type="submit"
            disabled={saving}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-semibold text-white bg-orange-600 hover:bg-orange-700 active:bg-orange-800 shadow-sm transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span>Guardando cambios...</span>
              </>
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Guardar Personalización</span>
              </>
            )}
          </button>
        </div>
      </form>
    );
  }
}
